import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const InvoiceList = React.lazy(() => import('@/modules/invoice/components/list/invoice-list'))
const InvoiceDetailView = React.lazy(() => import('@/modules/invoice/components/detail/invoice-detail-view'))
const InvoiceEditView = React.lazy(() => import('@/modules/invoiceV2/invoice-edit-view'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))

const invoiceRoutes = (
  <>
    <Route path='invoice/*' element={<RedirectToPlural />} />
    <Route path='invoices' Component={InvoiceList} handle={{ title: 'Rechnungen', options: { noBackgroundColor: true } }} />

    <Route path='invoices/:id' Component={InvoiceDetailView} />
    <Route path='invoices/:id/:action' Component={InvoiceDetailView} />

    <Route path='invoices/edit/:id/:hash?' Component={InvoiceEditView} />
    <Route path='invoices/new' Component={InvoiceEditView} />
    <Route path='invoices/new/customer/:customerId' Component={InvoiceEditView} />
    <Route path='invoices/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default invoiceRoutes
